import { RootState } from 'store/root-reducer';

export const jobApplicantSelector = ({ jobApplicant }: RootState) => jobApplicant;
